import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { CompassIcon } from 'lucide-react';
import { BASE } from '../basePath';

export default function NotFoundPage() {
    const { t } = useTranslation();
    return (
        <div className="h-full flex items-center justify-center p-8">
            <div className="max-w-md text-center space-y-5">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#e8efe9]">
                    <CompassIcon className="h-7 w-7 text-[#2d6a4f]" />
                </div>
                <div>
                    <div className="text-[11px] uppercase tracking-wider text-[#7a8077] mb-1">
                        404
                    </div>
                    <h1 className="text-2xl font-semibold text-[#1c2620]">
                        {t('Page not found')}
                    </h1>
                    <p className="text-sm text-[#5a6259] mt-2 leading-relaxed">
                        {t(
                            'Oops! The page you are looking for does not exist.',
                        )}
                    </p>
                </div>
                <Button
                    asChild
                    className="bg-[#2d6a4f] hover:bg-[#245741] text-white"
                >
                    <Link to={`${BASE}/project`}>{t('Go to home page')}</Link>
                </Button>
            </div>
        </div>
    );
}
